<template>
  <footer class="mt-auto">
    <section class="footer">
      <div class="container">
        <div class="content">
          <div class="img-footer">
            <img src="@/assets/img/logomgr.png" alt="" />
          </div>
          <div class="top">
            <p class="address-footer">
              {{ company.address }}
            </p>
            <div class="contact-footer">
              <a target="_blank" :href="`https://wa.me/${company.contact}`" title="Whatsapp" class="icon-contact"
                @mouseenter="enterCard" @mouseleave="leaveCard">
                <i class="ti ti-brand-whatsapp-filled"></i>
              </a>
              <a target="_blank" :href="`mailto:${company.email}`" title="Email" class="icon-contact"
                @mouseenter="enterCard" @mouseleave="leaveCard">
                <i class="ti ti-mail-filled"></i>
              </a>
            </div>
          </div>
          <div class="line"></div>
          <div class="brand-footer">
            <p>
              © {{ company.name }} {{ displayYear }}. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import api from '@/api';
export default {
  data() {
    return {
      isCursorInsideCard: false,
      company: {
        address: '',
        whatsapp: '',
        email: ''
      }
    };
  },
  computed: {
    displayYear() {
      const currentYear = new Date().getFullYear();
      const defaultYear = 2021;
      return currentYear > defaultYear
        ? `${defaultYear} - ${currentYear}`
        : `${defaultYear}`;
    },
  },
  async mounted() {
    try {
      const response = await api.get("Landing/company");
      this.company = response.data.data;
    } catch (error) {
      // console.error('Error fetching data:', error);
    }
  },
  methods: {
    enterCard() {
      this.isCursorInsideCard = true;
      this.$emit("cursor-enter", false);
    },
    leaveCard() {
      this.isCursorInsideCard = false;
      this.$emit("cursor-enter", true);
    },
  },
};
</script>